/**
 * SuperAdminRoute – Routebescherming voor SuperAdmin Dashboard
 * Alleen toegankelijk voor gebruikers met de rolvlag is_superuser (#647).
 * Parent route is al binnen ProtectedRoute, dus alleen superuser-check nodig.
 */

import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

function SuperAdminRoute({ children }) {
  const { user } = useAuthStore()

  const isSuperUser = Boolean(user?.is_superuser)  // rolvlag, nooit afgeleid uit tenant_id (#647)

  if (!isSuperUser) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default SuperAdminRoute
